// Module
var code = `<template>
  <require from="./top-bottom-instruments-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style>
      .top-bottom-instruments-widget-\${id} .ag-paging-panel {
        display: none !important;
      }

      .top-bottom-instruments-widget-\${id} .ag-header,
      .top-bottom-instruments-widget-\${id} .ag-cell {
        font-size: \${fontSize}px !important;
      }

      .top-bottom-instruments-widget-\${id} .ag-cell {
        line-height: \${rowHeight}px !important;
      }
  </style>
  <!-- beautify ignore:end -->

  <div class="top-bottom-instruments-widget top-bottom-instruments-widget-\${id}">
    <ag-grid-aurelia if.bind="!error" class="\${isInDashboard && themeService.darkTheme ? 'ag-theme-balham-dark' : 'ag-theme-balham ag-theme-balham-report'}" grid-options.bind="gridOptions">

      <ag-grid-column header-name="Instrument" field="name" editable="false"></ag-grid-column>

      <ag-grid-column header-name="Instrument" field="reportName" editable="false" hide-col="true"></ag-grid-column>

      <ag-grid-column header-name="Value" field="estimatedValueClosingBalance" editable="false" type="rightAligned" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="\${startFrom === TopBottomInstrumentsWidgetStartFrom.ToDateYearStart ? 'P&L YTD' : 'P&L'}" field="profitLossChangeYearToDate" editable="false" type="rightAligned" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="\${startFrom === TopBottomInstrumentsWidgetStartFrom.ToDateYearStart ? 'P&L YTD in %' : 'P&L in %'}" field="profitLossChangeYearToDateInPercent" type="rightAligned" editable="false" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="% of total holding" field="estimatedValuePercent" type="rightAligned" editable="false" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-loading-overlay-template>
        <mdc-circular-progress></mdc-circular-progress>
      </ag-loading-overlay-template>
    </ag-grid-aurelia>

    <message if.bind="error" class="portfolio-overview-widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;